import React, { useState } from "react";
import LogoSankhyaID from "../../commons/icons/logoSankhyaID";
import Utils from "../../commons/utils/utils";
import { Layout, Form, Col, Row, List } from "antd";

const { Header, Content, Footer } = Layout;
const year = Utils.getCurrentYear();


export default () => {

    const emails = extractEmailsFromUrl(window.location.href);

    function extractEmailsFromUrl(url) {
        
        const parametrosDaUrl = url.split("?")[1];
        let values = []
        if (parametrosDaUrl) {
            const listaDeParametros = parametrosDaUrl.split("&")
            const parameters = {}
            
            for (var i = 0; i < listaDeParametros.length; i++) {
                var parametro = listaDeParametros[i].split("=");
                var chave = parametro[0];
                var valor = parametro[1];
                parameters[chave] = valor;
    
                if (chave === "email") {
                    values =  valor.split(";")
                }
            }
            return values;
        }
    
    }

    return (
        <>
            <Layout className="layout" style={{ minHeight: "100vh", width: "100%" }}>
                <Header style={{ minHeight: "82px", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <LogoSankhyaID />
                </Header>
                <Content>
                    <div className="complete-data-container">
                        <div className="complete-data-header">
                            <p className="complete-data-title">Usuários não encontrados.</p>
                            <div className="complete-data-content">
                                Não existe nenhum usuário do Maha com os e-mails: <br/><br/>
                                { emails.map(values => (<spam>{values}<br/></spam>))}
                                <br/><p className="complete-data-description">Procure um responsável pelo Maha para criar seu usuário ou adicione ao seu ID um e-mail que já exista em algum usuário do Maha.</p>
                            </div>
                        </div>
                    </div>
                </Content>
                <Footer>
                    <div style={{ minHeight: "82px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <span>Copyright © {year} - Sankhya Gestão de Negócios. Todos os direitos reservados.</span>
                    </div>
                </Footer>
            </Layout>
        </>
    )
};
